import type { LoginFormCopy } from './models';
import { text as moduleText } from './text';
import { text as sharedText } from '@shared/text';

export const text = {
  loginFormCopy(isSubmitting: boolean): LoginFormCopy {
    return {
      title: moduleText.title,
      subtitle: moduleText.subtitle,
      submitButtonLabel: isSubmitting ? sharedText.loading : moduleText.submit,
      signUpPrompt: moduleText.signUpPrompt,
      signUpActionLabel: moduleText.signUpAction,
      forgotPasswordLabel: moduleText.forgotPassword,
    };
  },
};
